const Tag = ({ children, size = 'md', onClick, className = '' }) => {
  const sizeClass = size === 'sm' ? 'tag-sm' : '';
  const classes = ['tag', sizeClass, className].filter(Boolean).join(' ');

  return (
    <span className={classes} onClick={onClick}>
      {children}
    </span>
  );
};

export default Tag;
